import type { CrossReferenceState } from '../types';

export type CrossReferenceMatchColor = 'gray' | 'red' | 'green';

const EPSILON = 1e-6;

export const numbersEqual = (a: number, b: number): boolean => Math.abs(a - b) < EPSILON;

export const computeMatchColor = (
  hostValue: number | null | undefined,
  state: CrossReferenceState | undefined
): CrossReferenceMatchColor => {
  if (!state) return 'gray';
  // Without a numeric host value there's nothing to match against — stay
  // gray rather than green-by-coincidence on a sum-to-zero edge case.
  if (hostValue == null) return 'gray';

  const dataRows = state.rows.filter(row => !row.isPlaceholder && row.value !== null && row.value !== undefined);
  if (dataRows.length === 0) return 'gray';

  const sum =
    state.rowMode === 'multi_row'
      ? dataRows.reduce((acc, row) => acc + Number(row.value), 0)
      : Number(dataRows[0].value);

  return numbersEqual(sum, hostValue) ? 'green' : 'red';
};
